'use client';
import React from 'react';
import AppImage from '@/components/ui/AppImage';
import { Play, ArrowRight } from 'lucide-react';

const FEATURED = [
{
  id: 1,
  title: 'Начни здесь: Кто ты?',
  description: 'Первое видео для новых. Без сложных концепций — просто прямой опыт.',
  duration: '5:00',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_14df5b519-1765260901013.png",
  alt: 'Person meditating in soft morning light with peaceful expression',
  tag: 'Начало пути'
},
{
  id: 2,
  title: 'Настоящий момент — единственная реальность',
  description: 'Самое просматриваемое видео. Меняет точку зрения за 5 минут.',
  duration: '5:18',
  thumbnail: "https://images.unsplash.com/photo-1691687797542-8995c3c26197",
  alt: 'Sun rays breaking through forest canopy creating golden light beams',
  tag: '312K просмотров'
},
{
  id: 3,
  title: 'Страх — это иллюзия',
  description: 'Почему мы боимся себя и как это остановить. Глубокий разбор.',
  duration: '9:15',
  thumbnail: "https://images.unsplash.com/photo-1579729433139-5ac95bada0e9",
  alt: 'Man standing alone on empty road at dusk looking toward horizon',
  tag: '201K просмотров'
}];


export default function FeaturedSection() {
  return (
    <section id="featured" className="py-24 px-6 lg:px-10 2xl:px-16 bg-white">
      <div className="max-w-screen-2xl mx-auto">

        <div className="flex items-end justify-between mb-12">
          <div>
            <p className="text-xs tracking-widest uppercase text-[#7A7060] mb-3">Начать отсюда</p>
            <h2
              className="text-3xl md:text-4xl font-300 text-[#1C1710]"
              style={{ fontWeight: 300, letterSpacing: '-0.01em' }}>
              
              Рекомендуем
            </h2>
          </div>
          <button className="hidden md:flex items-center gap-2 text-sm text-[#7A7060] hover:text-[#1C1710] transition-colors">
            Смотреть все
            <ArrowRight size={14} />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {FEATURED?.map((item, index) =>
          <article key={item?.id} className="group cursor-pointer">
              {/* Large thumbnail */}
              <div className={`relative overflow-hidden rounded-2xl ${index === 0 ? 'aspect-[4/5]' : 'aspect-[4/3]'} bg-[#E8E0D0] mb-5`}>
                <AppImage
                src={item?.thumbnail}
                alt={item?.alt}
                fill
                className="object-cover transition-transform duration-700 group-hover:scale-105"
                sizes="(max-width: 768px) 100vw, 33vw" />
              
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />

                {/* Play button */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-md border border-white/40 flex items-center justify-center">
                    <Play size={22} className="text-white ml-0.5" fill="white" />
                  </div>
                </div>

                {/* Tag */}
                <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-black/40 backdrop-blur-sm text-white text-xs font-500">
                  {item?.tag}
                </div>

                {/* Duration */}
                <div className="absolute bottom-4 right-4 px-2 py-0.5 rounded bg-black/50 text-white text-xs tabular-nums">
                  {item?.duration}
                </div>
              </div>

              <h3
              className="text-lg font-600 text-[#1C1710] mb-2 group-hover:text-[#C49A6C] transition-colors leading-snug"
              style={{ fontWeight: 600 }}>
              
                {item?.title}
              </h3>
              <p className="text-sm text-[#7A7060] leading-relaxed">{item?.description}</p>
            </article>
          )}
        </div>
      </div>
    </section>);

}